export const COLOMBIA_SATELLITE_PRECIP_SOURCE_KEY = "SATELLITE_PRECIPITATION_FALLBACK";
export const COLOMBIA_SATELLITE_PRECIP_LAYER_KEY = "CO_SATELLITE_PRECIPITATION_ESTIMATE";

export const COLOMBIA_SATELLITE_PRECIP_LAYER_LABEL = "Satellite Precipitation Estimate";

export const COLOMBIA_SATELLITE_PRECIP_LAYER_DESCRIPTION =
  "Satellite-based precipitation estimate for supplemental regional context. This is not ground-based radar.";

export const COLOMBIA_SATELLITE_PRECIP_BADGE = "Satellite estimate";

export const COLOMBIA_SATELLITE_ESTIMATE_WARNING = "Estimate, not radar.";

export const COLOMBIA_SATELLITE_DEFAULT_OPACITY = 0.55;

export const COLOMBIA_SATELLITE_ATTRIBUTION =
  "Satellite precipitation estimate — supplemental context only; not radar.";
